require('../../core/require');
require('./page.css');
import { huitabSettings } from '../../shared/services/settings-loader';

// Désactivation du lien Interlocuteurs de coupures plan du site
if (!huitabSettings.feature_flipping.interlocuteurs_unitaire_et_masse) {
  const lienInterlocuteurs = document.getElementById('flipping_interlocuteurs_coupures_plan');
  if (lienInterlocuteurs !== null) lienInterlocuteurs.remove();
}
